import { Label } from "@/components/ui/label";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@/components/ui/select";
import React from "react";

interface LoggingVerbositySelectProps {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}

const LoggingVerbositySelect: React.FC<LoggingVerbositySelectProps> = ({
  value,
  onChange,
  disabled,
}) => (
  <div>
    <Label>Logging Verbosity</Label>
    <Select
      disabled={disabled}
      value={value ? "Debug" : "Standard"}
      onValueChange={(val) => onChange(val === "Debug")}
    >
      <SelectTrigger className="w-full">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="Standard">Standard</SelectItem>
        <SelectItem value="Debug">Debug</SelectItem>
      </SelectContent>
    </Select>
  </div>
);

export default LoggingVerbositySelect;
